export default __webpack_public_path__ + "1c3c5eae0d470b962ee60dd716591bf3.svg";